import React from "react";

import LockIcon from "@uui/Lock03";

import Typography from "@mui/material/Typography";

import { LABEL_FOR_PLAN } from "@app/analytics/account/Billing/constants";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";
import Stack, { Row } from "@rui/Stack";

import WorkspaceSettingsAccordion from "../components/WorkspaceSettingsAccordion";

const Upsell = ({ planLabel }: { planLabel: string | null }) => (
  <EmptyStateContainer spacing={1} border="none" sx={{ maxWidth: "100%" }}>
    <EmptyStateIcon Icon={LockIcon} padding={2} />
    <EmptyStateTitle>
      Not available{planLabel ? ` on the ${planLabel} plan` : ""}
    </EmptyStateTitle>
    <EmptyStateSubtext>
      For additional security and control features, upgrade to{" "}
      {LABEL_FOR_PLAN.enterprise_plus}
    </EmptyStateSubtext>
    <Link to={ROUTES.UPGRADE_ACCOUNT}>
      <Button>Upgrade</Button>
    </Link>
  </EmptyStateContainer>
);

const AdvancedModule = () => {
  const { currentPlan } = useBillingContext();
  const showUpsell = currentPlan.type !== "enterprise_plus";

  return (
    <WorkspaceSettingsAccordion
      title={`Advanced (${LABEL_FOR_PLAN.enterprise_plus} Required)`}
      subtitle="Manage SSO, domain capture, and data retention policy"
    >
      {showUpsell ? (
        <Upsell planLabel={currentPlan.label} />
      ) : (
        <Stack spacing={1}>
          <Typography variant="bodyPrimaryMed" color="shades.neutral.600">
            Get started with increased control & security
          </Typography>
          <Typography variant="bodySecondaryReg" color="shades.neutral.500">
            Please contact Read support to set up{" "}
            {LABEL_FOR_PLAN.enterprise_plus} features such as SSO/SAML, domain
            capture, and data retention.
          </Typography>
          <Row paddingTop={1}>
            <Button href={LINKS.EMAIL.SUPPORT}>Contact support</Button>
          </Row>
        </Stack>
      )}
    </WorkspaceSettingsAccordion>
  );
};

export default AdvancedModule;
